const DataTypes = {
  String: 'String',
  Int: 'Int',
  Float: 'Float',
  Date: 'Date'
};

export default DataTypes;
